export const environment = {
  production: false,
  clerkPublishableKey: 'pk_test_cGxlYXNhbnQtdGVycmFwaW4tNi5jbGVyay5hY2NvdW50cy5kZXYk',
  apiBaseUrl: 'https://api-staging.sentinel.sparecores.net',
  keeperBaseUrl: 'https://keeper.sparecores.net',
  sentryDsn: '',
  sentryEnvironment: 'development',
  posthogKey: 'phc_Fi3yxUniDNXMI6VBP25WSDQSTKiTrNd5UfY5siQoZMT',
  posthogHost: 'https://eu.i.posthog.com',
};
